import {IAppliedRule, RuleOperator, RuleResultType} from '../incase-domain/appliedRules';
import {ISlide} from '../incase-domain/slide';

export const isRuleInFocus = <T extends number | string>(
    appliedRule: IAppliedRule<T>,
    highlightedElementId: string,
    answerIndexOrId: T
): boolean => {
    const predicate = appliedRule.predicates[0];
    const result = appliedRule.results[0];
    const isSameElement = predicate.elementId === highlightedElementId;
    const isSameAnswer = predicate.answers.includes(answerIndexOrId);

    return isSameElement && isSameAnswer && predicate.operator === RuleOperator.IF && result.resultType === RuleResultType.SHOW_SLIDES;
};

export const isSlideUsedInAppliedRules = (slide: ISlide, appliedRules?: IAppliedRule[] | null): boolean => {
    if (!appliedRules?.length) return false;
    const slideId = String(slide._id);
    const elementIds = new Set((slide.elements ?? []).map((el) => el.id));
    return appliedRules.some(
        (rule) =>
            rule.predicates.some((predicate) => elementIds.has(predicate.elementId)) ||
            rule.results.some((result) => result.slideIds.some((id) => String(id) === slideId))
    );
};

export const appliedRulesReferenceHiddenSlides = (appliedRules: IAppliedRule[], slides: ISlide[]): boolean => {
    if (!appliedRules.length) return false;
    const hiddenSlides = slides.filter((slide) => slide.hidden);
    if (!hiddenSlides.length) return false;
    const hiddenSlideIds = new Set(hiddenSlides.map((slide) => String(slide._id)));
    const hiddenElementIds = new Set(hiddenSlides.flatMap((slide) => (slide.elements ?? []).map((el) => el.id)));
    return appliedRules.some(
        (rule) =>
            rule.predicates.some((predicate) => hiddenElementIds.has(predicate.elementId)) ||
            rule.results.some((result) => result.slideIds.some((id) => hiddenSlideIds.has(String(id))))
    );
};
